import { Header } from "../components/header";
import FriendsOne from "../assets/OAP_0490.jpg";
import FriendsTwo from "../assets/img-2.png";
import FriendsThree from "../assets/img-3.png";
import FriendsFour from "../assets/OAP_0662.jpg";
import { Footer } from "../components/footer";
import { useEffect, useState } from "react";
import { trackPageView } from "../utils/segment";
import { createClient } from "contentful";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";

export function Landing() {
  const [wineCollections, setWineCollections] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    trackPageView("Landing Page Viewed");
    handleFetchWinesCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const client = createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENTFUL_API_KEY,
  });

  const handleFetchWinesCollections = async () => {
    try {
      setLoading(true);
      const { items } = await client.getEntries({
        "sys.contentType.sys.id": "wineCollection",
        order: "sys.createdAt",
      });
      setWineCollections(items);
      setLoading(false);
    } catch (error) {
      toast.error(
        "Error fetching wines collections:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <>
      <Header />
      <div className="landing-container">
        <div className="intro-row">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-md-6 section-top">
                <h1>
                  Friends. <br />
                  Wine. Good Times.
                </h1>
                <h4>
                  Juicy Italian wines, best served with your favorite people
                </h4>
                <a href="/where-to-buy">
                  <button>Find a Bottle</button>
                </a>
              </div>
              <div className="col-12 col-md-6">
                <div className="image-collage">
                  <div className="image-collage-item-flex">
                    <img
                      src={FriendsOne}
                      alt="friends"
                      className="img-fluid first-img"
                    />
                    <img src={FriendsTwo} alt="friends" className="img-fluid" />
                  </div>
                  <div className="image-collage-item-flex">
                    <img
                      src={FriendsThree}
                      alt="friends"
                      className="img-fluid first-img"
                    />
                    <img
                      src={FriendsFour}
                      alt="friends"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="collection-row">
          <div className="container-fluid">
            <div className="row">
              <h4>Our Collection</h4>
              {loading ? (
                <div className="wine-collection-loading-state">
                  {[1, 2, 3, 4].map((item) => (
                    <div key={item}>
                      <Skeleton height={300} width={300} count={1} />
                      <Skeleton
                        width={150}
                        height={25}
                        className="wine-collection-loading-state-item"
                      />
                      <Skeleton
                        width={120}
                        height={25}
                        className="wine-collection-loading-state-item"
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="wine-collection">
                  {wineCollections.map((item, key) => (
                    <a href={`/our-wines${item.fields.tag.trim()}`} key={key}>
                      <div className="item">
                        <img
                          src={item.fields.collectionImage.fields.file.url}
                          alt="Wine"
                          className="img-fluid"
                        />
                        <h3>{item.fields.collectionName}</h3>
                        <h6>{item.fields.collectionDescription}</h6>
                      </div>
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
